<template>
  <div class="person-card" @click="cardClick">
    <div class="area-left">
      <div class="avatar">
        <img :src="user.avatar" v-if="user.avatar" />
        <img src='@/assets/pic/lotteryGift.png' v-else/>
      </div>
    </div>
    <div class="area-mid">
      <div class="nickname">
        <span class="text">{{ user.nickname }}</span>
        <i
          class="fa gender"
          :class="{
            'fa-mars': user.gender == 1,
            'fa-venus': user.gender == 2,
          }"
        ></i>
      </div>
      <div class="tags">
        <span
          v-if="user.noble_level > 0"
          class="noble-icon"
          :class="`noble-level-${user.noble_level}`"
        ></span>
        <span
          v-if="user.level"
          class="level-icon"
          :class="`level-icon${user.level}`"
        ></span>
        <span
          v-if="user.fans_level"
          class="fans-icon"
          :class="`fans-icon-${user.fans_level}`"
          >{{ user.badge_name }}</span
        >
      </div>
    </div>
    <div class="area-right">
      <!-- <div><span class="files" :class="numbetToTag(user.weekConsume)"><span class="fix-width">7</span></span></div> -->
      <div v-if="user.pay_in_30_days > 0">
        <span
          class="files"
          :class="numbetToTag(fractionFormat(user.pay_in_30_days))"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { amountData } from "@/mixins/amountData";
export default {
  mixins: [amountData],
  props: {
    user: {
      type: Object,
      default: function() {
        return {
          avatar:
            "https://huyaimg.msstatic.com/avatar/1048/60/1773492920f2b2384787e898c4c8b3_180_135.jpg?1534495397",
          nickname: "",
          level: 14,
          noble_level: 1,
          gender: 1,
          fans_level: 0,
          badgeName: "",
          weekConsume: 1128,
          pay_in_30_days: 23809,
          id: 1,
        };
      },
    },
  },
  methods: {
    cardClick() {
      this.$emit("cardClick");
    },
  },
};
</script>

<style lang="less" scoped>
.person-card {
  display: flex;
  padding: 0.3rem 0.24rem 0.24rem 0.3rem;
  width: 95%;
  border-radius: 0.12rem;
  background: #fff;
  margin: 0.2rem auto;
  cursor: pointer;
  .area-left {
    position: relative;
    width: 0.84rem;
    height: 0.84rem;
    margin-right: 0.2rem;
    .avatar {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 0.84rem;
      height: 0.84rem;
      border-radius: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
      }
    }
  }
  .area-mid {
    width: 2.8rem;
    text-align: left;
    .nickname {
      .text {
        display: inline-block;
        max-width: 2.4rem;
        font-size: 0.3rem;
        line-height: 0.3rem;
        color: #101010;
        font-weight: 500;
        margin-right: 0.1rem;
        vertical-align: middle;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .tags {
      & > span {
        margin: 0 0.06rem;
      }
      .fans-icon {
        vertical-align: middle;
        position: relative;
        top: -2px;
      }
    }
  }
  .area-right {
    flex: 1;
    text-align: right;
    font-size: 0.28rem;
    color: #101010;
    line-height: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
